export const htmlSpec = {
  content: '',
  attrs: {
    type: {
      default: 'html'
    },
    content: {
      default: ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: '.embercom-prosemirror-composer-html-block .intercom-interblocks-html-block'
  }],
  toDOM() {
    return ['div', {
      class: 'embercom-prosemirror-composer-mention'
    }];
  }
};